import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente } from '../../usuario/usuario-perfil';


/** Acessos permitidos a consulta da análise de representante */
export const acessosAnaliseRepresentante: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable()
export class CanActivateAnaliseRepresentante implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosAnaliseRepresentante);
    }
}
